import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-xhr-backend'
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: process.env.NODE_ENV === 'development',
    fallbackLng: [ 'pl', 'en', 'ru', 'hu', 'es', 'ko'],
    whitelist: ['pl', 'en', 'ru', 'hu', 'es', 'ko'],
    backend: {
      loadPath: '/locales/{{lng}}.json',
      allowMultiLoading: true
    },
    react: {
      wait: true,
    }
  })

export default i18n


export const getValueLang = lang => {
  switch (lang) {
    case 'pl': {
      return 1
    }
    case 'en': {
      return 2
    }
    case 'ru': {
      return 4
    }
    case 'hu': {
      return 5
    }
    case 'es': {
      return 7
    }
    case 'ko': {
      return 8
    }
    default: {
      return 1
    }
  }
}
